// extracted by mini-css-extract-plugin
export default {"Page":"Page_Page__nKja9","Header":"Page_Header__FElFz","Content":"Page_Content__oa2Yo"};